import React, {useEffect, useMemo, useState, useContext} from "react";
import DataTable, {createTheme} from "react-data-table-component";
import logo from '../../assets/editer.png';
import {Link, useNavigate} from "react-router-dom";
import '../../styles/TableHome.css';
import dateService from "../../services/dateService";
import Requetes from "../../services/Requetes";
import Header from "../../components/Header";
import ReturnButton from "../../components/BoutonRetour/ReturnButton";
import Loading from "../../components/Loading/Loading";
import {useLocation} from "react-router";
import BreadcrumbsItem from "../../components/BreadcrumbsItem";

function InterventionsArchives() {
    const [interventions, setInterventions] = useState([]);
    const [table, setTable] = useState(true);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const location = useLocation();
    const route = {
        name: "Interventions Passées",
        path: location.pathname,
        state: ""
    }
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(5);
    const [offset, setOffset] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTimeout, setSearchTimeout] = useState(null);

    const fetchIntervention = async (currentOffset, limit) => {
        try {
            let response = await Requetes.getInterventionPast(currentOffset, limit, searchTerm);
            let res = [];
            const interventionsAVenir = Object.values(response.data);
            if (interventionsAVenir.length > 0) {
                for (const i of interventionsAVenir) {
                    if(i instanceof Object){
                        i.etat = await etatPvi(i.NumeroIntervention);
                        res.push(i);
                    }else{
                        setTotalRows(Number(i));
                    }
                }
            }
            setInterventions(res);
            setLoading(false);
        } catch (e) {
            console.log(e);
        }
    }

    const handlePageChange = (page) => {
        const newOffset = (page - 1) * perPage;
        setOffset(newOffset);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        setPerPage(newPerPage);
        const newOffset = (page - 1) * newPerPage;
        setOffset(newOffset);
    };
    // const fetchIntervention = async () => {
    //     try {
    //         let response = await Requetes.getInterventionToCome();
    //         let res = [];
    //         const interventionsArchive = response.data.filter(function (item) {
    //             return new Date(item.DateFin) < new Date();
    //         }).sort(function (a, b) {
    //             return new Date(b.DateDebut) - new Date(a.DateDebut);
    //         });
    //         if (interventionsArchive.length > 0) {
    //             for (const i of interventionsArchive) {
    //                 i.etat = await etatPvi(i.NumeroIntervention);
    //                 res.push(i);
    //             }
    //         }
    //         setTimeout(() => {
    //             setInterventions(res);
    //         }, 200);
    //         setTimeout(() => {
    //             setLoading(false);
    //         }, 500)
    //     } catch (e) {
    //         console.log(e);
    //     }
    // }

    const etatPvi = async (pvi) => {
        {
            let response = await Requetes.pviExist(pvi)
            if (response.data == null || response.data == false) {
                return "Non Rédigé"
            } else {
                return response.data.etat;
            }
        }
    }

    useEffect(() => {
        fetchIntervention(offset, perPage);
    }, [offset, perPage, searchTerm]);

    // Clear pending debounce timeout when it changes or on unmount
    useEffect(() => {
        return () => {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
        }
    }, [searchTimeout]);


    const columns = [
        {
            name: "Début",
            selector: (row) => dateService.formatDateHours(row.DateDebut),
            sortable: true,
            wrap: true,
            width: "110px",
            style: {
                textAlign: "left"
            }
        },

        {
            name: "Fin",
            selector: (row) => dateService.formatDateHours(row.DateFin),
            sortable: true,
            wrap: true,
            width: "110px",
            style: {
                textAlign: "left"
            }
        },
        {
            name: "Client",
            selector: (row) => row.Client,
            sortable: true,
            wrap: true,
            width: "150px",
            style: {
                textAlign: "left"
            }
        },

        {
            name: "Numéro de Dossier",
            selector: (row) => row.NumDossier,
            sortable: true,
            wrap: true,
            width: "150px",
            style: {
                textAlign: "left"
            },
            cell: (row) => (
                <div>
                    <div>
                        {row.NumDossier !== undefined ? row.NumDossier : "Pas de Num Dossier"}
                        <text></text>
                    </div>
                </div>
            )
        },
        {
            name: "Lieu d'intervention",
            selector: (row) => row.LieuIntervention,
            sortable: true,
            wrap: true,
            width: "150px",
            style: {
                textAlign: "left !important"
            },
            cell: (row) => (
                <div>
                    <div className="openbtn">
                        {row.LieuIntervention != ', ' ? row.LieuIntervention : "Pas de lieu d'intervention renseigné"}
                    </div>
                </div>
            )
        },

        {
            name: "Libellé",
            selector: (row) => row.Libelle,
            sortable: true,
            wrap: true,
            style: {
                textAlign: "left"
            }
        },
        {
            name: "Intervenants",
            selector: (row) => row.Intervenants,
            sortable: true,
            wrap: true,
            cell: (row) => {
                let stringArray = row.Intervenants;
                if (stringArray != null ){
                    return <div>
                        {stringArray.map(str => <div>{str}</div>)}
                    </div>
                }else{
                    return  "";
                }
            },
            width: "200px",
            style: {
                textAlign: "left"
            }
        },
        {
            name: "PVI",
            selector: (row) => row.etat,
            sortable: true,
            wrap: true,
            width: "150px",
            style: {
                textAlign: "left"
            }
        },
        {
            button: true,
            width: "40px",
            cell: (row) => (
                <div className="App">
                    <div className="openbtn text-center">
                        <Link to={'/recap/' + row.NumeroIntervention}
                              style={{border: "none"}}
                              state={{pviEBP: row}}
                        >
                            <img src={logo} style={{width: '60%'}} alt={"logo-edit"}/>
                        </Link>
                    </div>
                </div>
            )
        }
    ];

    const options = {
        rowsPerPageText: 'lignes par page',
        rangeSeparatorText: 'sur'
    }

    createTheme('solarized', {
        background: {
            default: 'white',
        },
        striped: {
            default: '#EBEBEB'
        },
    },)

    const customStyles = {

        headCells: {
            style: {
                color: 'white',
                background: '#04C3FF',
            },
        },
    };

    return (<>
            <Header/>
             <BreadcrumbsItem route={route}/>
            <div className='containerTab'>
                {/*<ReturnButton title={"Interventions Archivées"} text="" link={""}/>*/}
                {!loading &&
                    <div className="App">
                        <div className="card table-style">
                            <div style={{ padding: '1rem' }}>
                                    <input
                                        type="text"
                                        placeholder="Rechercher une intervention..."
                                        value={searchTerm}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            setSearchTerm(value);
                                        
                                            // Clear any existing timeout (debounce)
                                            if (searchTimeout) {
                                                clearTimeout(searchTimeout);
                                            }
                                        
                                            // Set a new timeout which only resets offset so the useEffect
                                            // (which depends on searchTerm and offset) will trigger the fetch.
                                            const timeout = setTimeout(() => {
                                                setOffset(0);
                                            }, 500);
                                        
                                            setSearchTimeout(timeout);
                                        }}
                                        style={{
                                            width: '100%',
                                            padding: '0.5rem',
                                            border: '1px solid #ccc',
                                            borderRadius: '4px',
                                            marginBottom: '1rem'
                                        }}
                                    />
                            </div>
                            <DataTable
                                className="table table-striped"
                                title=""
                                columns={columns}
                                data={interventions}
                                pagination
                                paginationServer
                                paginationPerPage={perPage}
                                paginationTotalRows={totalRows}
                                onChangeRowsPerPage={handlePerRowsChange}
                                onChangePage={handlePageChange}
                                paginationComponentOptions={options}
                                paginationRowsPerPageOptions={[5, 10]}
                                paginationDefaultPage={Math.floor(offset / perPage) + 1}
                                noDataComponent="Pas d'interventions"
                                theme="solarized"
                                striped='true'
                                customStyles={customStyles}
                                subHeaderAlign='center'
                                defaultSortField={"Début"}
                                onRowClicked={row => navigate('/recap/' + row.NumeroIntervention, { state: { pviEBP: row, toRefresh: true } })}
                            />
                        </div>
                    </div>
                    || <Loading/>
                }
            </div>
        </>

    );
}

export default InterventionsArchives;